<template>
  <el-card class="demo-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="manufacturerCode">
          <el-select v-model="form.manufacturerCode" placeholder="设备厂商" clearable>
            <el-option
              v-for="item in facturerList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="keyWord">
          <el-input v-model="form.keyWord" placeholder="接入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="protocolCode">
          <el-select v-model="form.protocolCode" placeholder="接入协议" clearable>
            <el-option
              v-for="item in protocolList"
              :key="item.protocolCode"
              :label="item.protocolName"
              :value="item.protocolCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="deviceTypeCode">
          <el-select v-model="form.deviceTypeCode" placeholder="类型归属" clearable>
            <el-option
              v-for="item in deviceTypeList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">搜索</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" :disabled="!$hasAccess('create')" @click="addHandle"
            >新增</el-button
          >
          <el-button
            type="danger"
            :disabled="!$hasAccess('delete') || !selectionList.length"
            @click="delHandle()"
            >删除</el-button
          >
          <el-button
            v-if="showJumpBtn"
            type="primary"
            :disabled="!$hasAccess('read')"
            @click="jumpHandle()"
            >智慧安防设备管理</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      :height="`calc(100vh - 200px - ${formHeight}px)`"
      @selection-change="selectionChange"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column label="设备厂商" prop="manufacturerName" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ factureMap[row.manufacturer] || row.manufacturer }}
        </template>
      </el-table-column>
      <el-table-column label="接入模板名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="接入协议"
        prop="protocolTypeName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="类型归属" prop="deviceTypeName" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ deviceTypeMap[row.deviceType] || row.deviceType }}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="description" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="创建时间"
        prop="creationTime"
        :formatter="formatDate"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="{ row }">
          <el-button size="mini" :disabled="!$hasAccess('update')" @click.stop="editHandle(row)"
            >编辑</el-button
          >
          <el-button size="mini" :disabled="!$hasAccess('delete')" @click.stop="delHandle(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>

    <EditDialog
      v-if="editDialogShow"
      :show.sync="editDialogShow"
      :type="editType"
      :detailRow="detailRow"
      @reload="getList"
    ></EditDialog>
  </el-card>
</template>

<script>
import { IOTDeviceTemplateApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { HikApi } from '@wiz-api/zhengning2'
import tableHeightMixin from '@/mixins/tableHeightMixin'
import EditDialog from './EditDialog'

const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const dataCategoryApi = new DataCategoryApi()
const hikApi = new HikApi()

export default {
  name: 'accessTemplate',
  mixins: [tableHeightMixin],
  components: {
    EditDialog,
  },
  computed: {
    showJumpBtn() {
      return Wiz.globalSettings.dynamicModules?.modules['wiz-iot-management-tongre']?.config
        ?.showHKJumpBtn
    },
  },
  data() {
    return {
      facturerList: [],
      deviceTypeList: [],
      protocolList: [],
      factureMap: {},
      deviceTypeMap: {},
      dateRange: [],
      form: {
        manufacturerCode: '',
        keyWord: '',
        protocolCode: '',
        deviceTypeCode: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      selectionList: [],
      editDialogShow: false,
      editType: 'add',
      detailRow: {},
      exportLoading: false,
    }
  },
  methods: {
    formatDate(row, column, cellValue) {
      if (cellValue) return this.dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    selectionChange(val) {
      this.selectionList = val
    },
    addHandle() {
      this.editType = 'add'
      this.editDialogShow = true
    },
    editHandle(row) {
      this.editType = 'edit'
      this.detailRow = row
      this.editDialogShow = true
    },
    delHandle(row) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtontext: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(async () => {
        let ids = []
        if (row) {
          ids = [row.id]
        } else {
          ids = this.selectionList.map((item) => {
            return item.id
          })
        }
        const [err] = await ioTdeviceManagementApi.deleteMany({
          ids,
        })
        if (!err) {
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    // 跳转海康平台
    async jumpHandle() {
      // 获取token
      const [err, res] = await hikApi.createHikToken()
      if (!err && res) {
        window.open(
          `https://10.71.58.46:443/xauthplus-plugin/thirdLogin?type=third&token=${res}`,
          '_blank'
        )
      }
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await ioTdeviceManagementApi.getList({
        ...this.form,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        this.initPagination.total = res.totalCount
      }
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') {
            // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.factureMap = facturerList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.deviceTypeMap = deviceTypeList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.getList()
      }
    },
    // 协议名称列表
    async getProtocolList() {
      const [err, res] = await ioTdeviceManagementApi.getProtocolList({
        SkipCount: 0,
        MaxResultCount: 99,
      })
      if (!err) {
        this.protocolList = res.items
      } else {
        this.protocolList = []
      }
    },
  },
  async created() {
    this.getProtocolList()
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped></style>
